import { C } from "../lib/theme";

export function Eyebrow({ children }) {
  return (
    <div
      style={{
        fontSize: 10.5,
        fontWeight: 700,
        color: C.hunter,
        textTransform: "uppercase",
        letterSpacing: 1.5,
        marginBottom: 6,
      }}
    >
      {children}
    </div>
  );
}
